import React from 'react';
import PropTypes from 'prop-types';
import { VertModal, VertTypography } from '@vertem-core/vertice-ds';
import 'Assets/styles/default/components/InformationModal/InformationModal.less';

const { Paragraph } = VertTypography;

const InformationModal = ({ isOpen, onCancel, title }) => {
  return (
    <VertModal
      key={'InformationModal'}
      open={isOpen}
      onCancel={onCancel}
      destroyOnClose
      zIndex={2000}
      width={626}
      centered
      wrapClassName="modal-information-wrapper"
    >
      <>
        {title && <Paragraph className="title">{title}</Paragraph>}
        <img
          src={process.env.REACT_APP_IMAGE_INFORMATION_MODAL}
          alt={title || 'Information'}
        />
      </>
    </VertModal>
  );
};

InformationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  title: PropTypes.string,
};

export default InformationModal;
